export default __webpack_public_path__ + "static/media/bicarb-mixing.5bb32484.jpg";